import React, { useState } from "react";
import {
  Box,
  TextField,
  Autocomplete,
  Button,
  Alert,
  IconButton,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
// import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { baseUrl } from "../../helper/urls";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

// const ServiceType = [
//   "Essay Counseling",
//   "College Counseling",
//   "Essay + College Counseling",
// ];
const ServiceType = [
  "Essay Counseling",
  "College Advising",
  "Comprehensive Service (Essay, College Advising)",
  // "AI/ML Engineering",
  "Full Support Counseling",
];

export default function CounselorRatesForm({
  counselorId,
  handleClose,
  fetchCounselors,
}) {
  const { token } = useSelector((state) => state.auth);
  const [rates, setRates] = useState([
    {
      service_type: "",
      rate_1_slot: "",
      rate_5_slot: "",
      rate_10_slot: "",
      rate_15_slot: "",
      commission: "",
    },
  ]);
  console.log("rates: ", rates);
  const [error, setError] = useState("");

  const handleChange = (index, field, value) => {
    const updatedRates = [...rates];
    updatedRates[index][field] = value;
    setRates(updatedRates);
  };

  const handleAddRow = () => {
    if (rates.length < ServiceType.length) {
      setRates([
        ...rates,
        {
          service_type: "",
          rate_1_slot: "",
          rate_5_slot: "",
          rate_10_slot: "",
          rate_15_slot: "",
          commission: "",
        },
      ]);
    }
  };

  const handleRemoveRow = (index) => {
    const updatedRates = [...rates];
    updatedRates.splice(index, 1);
    setRates(updatedRates);
  };

  const isValidRate = (value) => {
    const num = parseFloat(value);
    return !isNaN(num) && num > 0;
  };

  const handleSubmit = async () => {
    for (const rate of rates) {
      if (
        !rate.service_type ||
        !isValidRate(rate.rate_1_slot) ||
        !isValidRate(rate.rate_5_slot) ||
        !isValidRate(rate.rate_10_slot) ||
        !isValidRate(rate.rate_15_slot) ||
        !isValidRate(rate.commission)
      ) {
        setError("All fields must be filled and numeric values > 0.");
        return;
      }
    }

    const payload = {
      status: 1,
      price_per_hour: rates.map((r) => ({
        ...r,
        rate_1_slot: parseFloat(r.rate_1_slot),
        rate_5_slot: parseFloat(r.rate_5_slot),
        rate_10_slot: parseFloat(r.rate_10_slot),
        rate_15_slot: parseFloat(r.rate_15_slot),
        commission: parseFloat(r.commission),
      })),
    };

    setError("");
    console.log("Payload to send:", payload);
    // Submit logic goes here
    try {
      const response = await axios.put(
        `${baseUrl}/api/counselors/${counselorId}/status`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      Swal.fire("Success", "Counselor Approved  Successfully!", "success");
      handleClose();
      fetchCounselors();
      console.log("response: ", response);
    } catch (error) {
      console.log("error: ", error);
    }
  };

  // Get available service types excluding those already selected
  const getAvailableOptions = (currentIndex) => {
    const selectedTypes = rates
      .map((r, idx) => (idx !== currentIndex ? r.service_type : null))
      .filter(Boolean);
    return ServiceType.filter((type) => !selectedTypes.includes(type));
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 3 }}>
      {error && <Alert severity="error">{error}</Alert>}

      {rates.map((rate, index) => (
        <Box key={index} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Autocomplete
            fullWidth
            options={getAvailableOptions(index)}
            value={rate.service_type}
            onChange={(event, newValue) =>
              handleChange(index, "service_type", newValue || "")
            }
            renderInput={(params) => (
              <TextField {...params} label="Select Service Type" />
            )}
          />
          <TextField
            type="number"
            label="1 slot"
            inputProps={{ min: 1 }}
            value={rate.rate_1_slot}
            onChange={(e) => handleChange(index, "rate_1_slot", e.target.value)}
          />
          <TextField
            type="number"
            label="5 slot"
            inputProps={{ min: 1 }}
            value={rate.rate_5_slot}
            onChange={(e) => handleChange(index, "rate_5_slot", e.target.value)}
          />
          <TextField
            type="number"
            label="10 slot"
            inputProps={{ min: 1 }}
            value={rate.rate_10_slot}
            onChange={(e) =>
              handleChange(index, "rate_10_slot", e.target.value)
            }
          />
          <TextField
            type="number"
            label="15 slot"
            inputProps={{ min: 1 }}
            value={rate.rate_15_slot}
            onChange={(e) =>
              handleChange(index, "rate_15_slot", e.target.value)
            }
          />
          <TextField
            type="number"
            label="Commission %"
            inputProps={{ min: 1 }}
            value={rate.commission}
            onChange={(e) => handleChange(index, "commission", e.target.value)}
          />
          {index > 0 && (
            <Tooltip title={"Remove Service"}>
              <IconButton onClick={() => handleRemoveRow(index)}>
                <RemoveIcon sx={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          )}
          {rates.length < ServiceType.length && (
            <Tooltip title={"Add Service"}>
              <IconButton onClick={handleAddRow}>
                <AddIcon sx={{ color: "red" }} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ))}

      {/* {rates.length < ServiceType.length && (
        <Button
          variant="outlined"
          onClick={handleAddRow}
          startIcon={<AddIcon />}
        >
          Add Service
        </Button>
      )} */}

      <Button variant="contained" onClick={handleSubmit}>
        Submit
      </Button>
    </Box>
  );
}

// import React, { useState } from "react";
// import { Box, TextField, Autocomplete, Button, Alert, IconButton } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";

// const ServiceType = ["essay", "college", "essay + general"];

// export default function CounselorRatesForm() {
//   const [visibleRows, setVisibleRows] = useState(1); // start with 1 row
//   const [rates, setRates] = useState(
//     ServiceType.map((service) => ({
//       service_type: service,
//       rate_1_slot: "",
//       rate_5_slot: "",
//       rate_10_slot: "",
//       rate_15_slot: "",
//       commission: "",
//     }))
//   );
//   const [error, setError] = useState("");

//   const handleChange = (index, field, value) => {
//     const updatedRates = [...rates];
//     updatedRates[index][field] = value;
//     setRates(updatedRates);
//   };

//   const isValidRate = (value) => {
//     const num = parseFloat(value);
//     return !isNaN(num) && num > 0;
//   };

//   const handleSubmit = () => {
//     for (let i = 0; i < visibleRows; i++) {
//       const rate = rates[i];
//       if (
//         !isValidRate(rate.rate_1_slot) ||
//         !isValidRate(rate.rate_5_slot) ||
//         !isValidRate(rate.rate_10_slot) ||
//         !isValidRate(rate.rate_15_slot) ||
//         !isValidRate(rate.commission)
//       ) {
//         setError("All numeric fields must be greater than 0.");
//         return;
//       }
//     }

//     const payload = {
//       status: 1,
//       price_per_slot: rates.slice(0, visibleRows).map((r) => ({
//         ...r,
//         rate_1_slot: parseFloat(r.rate_1_slot),
//         rate_5_slot: parseFloat(r.rate_5_slot),
//         rate_10_slot: parseFloat(r.rate_10_slot),
//         rate_15_slot: parseFloat(r.rate_15_slot),
//         commission: parseFloat(r.commission),
//       })),
//     };

//     setError("");
//     console.log("Payload to send:", payload);
//     // Submit logic goes here
//   };

//   const handleAddRow = () => {
//     if (visibleRows < ServiceType.length) {
//       setVisibleRows(visibleRows + 1);
//     }
//   };

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2 }}>
//       {error && <Alert severity="error">{error}</Alert>}

//       {rates.slice(0, visibleRows).map((rate, index) => (
//         <Box key={index} sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//           <Autocomplete
//             fullWidth
//             options={[ServiceType[index]]}
//             value={rate.service_type}
//             disabled
//             renderInput={(params) => (
//               <TextField {...params} label="Select Service Type" />
//             )}
//           />
//           <TextField
//             type="number"
//             label="1 slot"
//             inputProps={{ min: 1 }}
//             value={rate.rate_1_slot}
//             onChange={(e) => handleChange(index, "rate_1_slot", e.target.value)}
//           />
//           <TextField
//             type="number"
//             label="5 slot"
//             inputProps={{ min: 1 }}
//             value={rate.rate_5_slot}
//             onChange={(e) => handleChange(index, "rate_5_slot", e.target.value)}
//           />
//           <TextField
//             type="number"
//             label="10 slot"
//             inputProps={{ min: 1 }}
//             value={rate.rate_10_slot}
//             onChange={(e) => handleChange(index, "rate_10_slot", e.target.value)}
//           />
//           <TextField
//             type="number"
//             label="15 slot"
//             inputProps={{ min: 1 }}
//             value={rate.rate_15_slot}
//             onChange={(e) => handleChange(index, "rate_15_slot", e.target.value)}
//           />
//           <TextField
//             type="number"
//             label="Commission %"
//             inputProps={{ min: 1 }}
//             value={rate.commission}
//             onChange={(e) => handleChange(index, "commission", e.target.value)}
//           />
//         </Box>
//       ))}

//       {visibleRows < ServiceType.length && (
//         <Button variant="outlined" onClick={handleAddRow} startIcon={<AddIcon />}>
//           Add Service Type
//         </Button>
//       )}

//       <Button variant="contained" onClick={handleSubmit}>
//         Submit
//       </Button>
//     </Box>
//   );
// }

// import React, { useState } from "react";
// import { Box, TextField, Autocomplete, Button, Alert } from "@mui/material";

// const ServiceType = ["essay", "college", "essay + general"];

// export default function CounselorRatesForm() {
//   const [rates, setRates] = useState(
//     ServiceType.map((service) => ({
//       service_type: service,
//       rate_1_slot: "",
//       rate_5_slot: "",
//       rate_10_slot: "",
//       rate_15_slot: "",
//       commission: "",
//     }))
//   );
//   const [error, setError] = useState("");

//   const handleChange = (index, field, value) => {
//     const updatedRates = [...rates];
//     updatedRates[index][field] = value;
//     setRates(updatedRates);
//   };

//   const isValidRate = (value) => {
//     const num = parseFloat(value);
//     return !isNaN(num) && num > 0;
//   };

//   const handleSubmit = () => {
//     for (const rate of rates) {
//       if (
//         !isValidRate(rate.rate_1_slot) ||
//         !isValidRate(rate.rate_5_slot) ||
//         !isValidRate(rate.rate_10_slot) ||
//         !isValidRate(rate.rate_15_slot) ||
//         !isValidRate(rate.commission)
//       ) {
//         setError("All numeric fields must be greater than 0.");
//         return;
//       }
//     }

//     const payload = {
//       status: 1,
//       price_per_slot: rates.map((r) => ({
//         ...r,
//         rate_1_slot: parseFloat(r.rate_1_slot),
//         rate_5_slot: parseFloat(r.rate_5_slot),
//         rate_10_slot: parseFloat(r.rate_10_slot),
//         rate_15_slot: parseFloat(r.rate_15_slot),
//         commission: parseFloat(r.commission),
//       })),
//     };

//     setError("");
//     console.log("Payload to send:", payload);
//     // Submit via fetch or axios here
//   };

//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2 }}>
//       {error && <Alert severity="error">{error}</Alert>}
//       {rates.map((rate, index) => (
//         <Box key={index} sx={{ display: "flex", gap: 1 }}>
//           <Autocomplete
//             fullWidth
//             options={ServiceType}
//             value={rate.service_type}
//             onChange={(event, newValue) =>
//               handleChange(index, "service_type", newValue || "")
//             }
//             renderInput={(params) => (
//               <TextField {...params} label="Select Service Type" />
//             )}
//           />
//           <TextField
//             type="number"
//             label="1 slot"
//             inputProps={{ min: 1 }}
//             value={rate.rate_1_slot}
//             onChange={(e) => handleChange(index, "rate_1_slot", e.target.value)}
//           />
//           <TextField
//             type="number"
//             label="5 slot"
//             inputProps={{ min: 1 }}
//             value={rate.rate_5_slot}
//             onChange={(e) => handleChange(index, "rate_5_slot", e.target.value)}
//           />
//           <TextField
//             type="number"
//             label="10 slot"
//             inputProps={{ min: 1 }}
//             value={rate.rate_10_slot}
//             onChange={(e) =>
//               handleChange(index, "rate_10_slot", e.target.value)
//             }
//           />
//           <TextField
//             type="number"
//             label="15 slot"
//             inputProps={{ min: 1 }}
//             value={rate.rate_15_slot}
//             onChange={(e) =>
//               handleChange(index, "rate_15_slot", e.target.value)
//             }
//           />
//           <TextField
//             type="number"
//             label="Commission %"
//             inputProps={{ min: 1 }}
//             value={rate.commission}
//             onChange={(e) => handleChange(index, "commission", e.target.value)}
//           />
//         </Box>
//       ))}
//       <Button variant="contained" onClick={handleSubmit}>
//         Submit
//       </Button>
//     </Box>
//   );
// }
